export default __webpack_public_path__ + "static/media/cardself2.18f61071.png";